<ng-template #listItemTemplateInternal let-item="item">
	<i class="ico ico-workspace" *ngIf="dataView.mode !== 'EDIT'"></i>
	<div class="text" [style.text-decoration]="item.targetElement?.tailored ? 'line-through' : 'none'">
		<h4 class="label-text">
			{{ item.targetWorkspace.name }}
			<i
				[ngClass]="getProcessInterfaceIconClasses(item)"
				*ngIf="item.isProcessInterface"
				title="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }} "
			></i>
		</h4>
		<h5 class="workspace-path">{{ item.targetWorkspace.path }}</h5>
		<p *ngIf="dataView.mode !== 'EDIT'">{{ item.comment }}</p>
		<input
			#commentInput
			[id]="'cipt' + item.id"
			*ngIf="dataView.mode === 'EDIT'"
			class="comment-input"
			type="text"
			placeholder="{{ 'process.element.associationBrowser.comment.placeholder' | translate }}"
			[(ngModel)]="item.comment"
			[ngModelOptions]="{ updateOn: 'blur' }"
			(ngModelChange)="commentChanged(item)"
		/>
	</div>
</ng-template>

<ng-template #listItemTemplate let-item>
	<a class="label clickable" (click)="navigateAndClose(item)" *ngIf="!commentOnly && dataView.mode !== 'EDIT'">
		<ng-container *ngTemplateOutlet="listItemTemplateInternal; context: { item: item }"></ng-container>
	</a>
	<ng-container *ngIf="commentOnly || dataView.mode === 'EDIT'">
		<div class="label">
			<ng-container *ngTemplateOutlet="listItemTemplateInternal; context: { item: item }"></ng-container>
		</div>
	</ng-container>
</ng-template>

<ng-template #listHeaderTemplate let-data>
	<h3
		*ngIf="commentOnly"
		class="assoc-list-header"
		[translate]="'process.element.associationCombined.comments.workspacesContaining'"
		[translateParams]="{ comment: targetElementLabel }"
	></h3>
	<h3
		*ngIf="!commentOnly"
		class="assoc-list-header"
		[translate]="'process.element.associationCombined.workspacesContaining'"
		[translateParams]="{ name: targetElementLabel }"
	></h3>
</ng-template>

<stages-dialog2 #dialog class="autoHeight">
	<stages-dialog-header></stages-dialog-header>
	<ng-container *ngIf="assocType | async as assoctype">
		<h1
			*ngIf="dataView.mode === 'DELETE'"
			[translate]="'process.element.associationCombined.delete'"
			[translateParams]="{ name: targetElementLabel }"
		></h1>

		<h1
			*ngIf="dataView.mode !== 'DELETE' && commentOnly"
			[translate]="'process.element.associationCombined.comments.fromMultipleWorkspaces'"
		></h1>
		<h1
			*ngIf="dataView.mode !== 'DELETE' && !commentOnly"
			[translate]="'process.element.associationCombined.fromMultipleWorkspaces'"
			[translateParams]="{ type: (assoctype | translate) }"
		></h1>
	</ng-container>
	<div class="scrollable-content">
		<stages-responsive-data-view
			#dataView
			[dataSource]="dataSource"
			[listItemTemplate]="listItemTemplate"
			[listHeaderTemplate]="listHeaderTemplate"
			translateNone="none"
			[idFn]="getAssocId"
			[disabledFn]="isDisabled"
			[pageSize]="pageSize"
		>
		</stages-responsive-data-view>
		<div class="buttons-bottom">
			<div class="spacer"></div>
			<button type="button" class="button sm cancel" name="cancel" (click)="close()" translate="cancel"></button>
			<button
				type="submit"
				class="button sm delete"
				translate="remove"
				(click)="delete()"
				[disabled]="dataView.selection.selected.length === 0"
				*ngIf="dataView.mode === 'DELETE'"
			></button>
			<button
				type="submit"
				class="button sm save"
				translate="save"
				(click)="save()"
				*ngIf="dataView.mode === 'EDIT'"
			></button>
		</div>
	</div>
</stages-dialog2>
